/* TypeScript file generated from EditingProvider.re by genType. */
/* eslint-disable import/first */


import * as React from 'react';

// tslint:disable-next-line:no-var-requires
const EditingProviderBS = require('./EditingProvider.bs');

// tslint:disable-next-line:interface-over-type-literal
export type Props = { readonly children: React.ReactNode };

export const make: React.ComponentType<{ readonly children: React.ReactNode }> = EditingProviderBS.make;
